import { createContext } from 'react';
import { DateTime } from 'luxon';
const CalendarContext = createContext({
    view: 'day',
    date: DateTime.now(),
    value: new Date(),
    range: [null, null],
    selectRange: false,
    setView: () => { },
    setDate: () => { },
    setRange: () => { },
    onChange: () => { },
    onRangeChange: () => { },
});
export default CalendarContext;
